export const dynamicCollectionRendererKey = 'dynamic-collections-renderer';
export const dynamicElementsArrayRendererKey =
  'dynamic-elements-array-renderer';
export const dynamicElementsAuthorKey = 'dynamic-elements-author';
export const dynamicElementsBadgeKey = 'dynamic-elements-badge';
export const dynamicElementsBestPerformingArticlesFiltersKey =
  'dynamic-elements-best-performing-articles-filters';
export const dynamicElementsButtonKey = 'dynamic-elements-button';
export const dynamicElementsDiscountLabel = 'dynamic-elements-discount-label';
export const dynamicElementsDropdown = 'dynamic-elements-dropdown';
export const dynamicElementsGridBuilder = 'dynamic-elements-grid-builder';
export const dynamicElementsIconKey = 'dynamic-elements-icon';
export const dynamicElementsLinkKey = 'dynamic-elements-link';
export const dynamicElementsHotListIndicatorKey = 'dynamic-hot-list-indicator';
export const dynamicElementsListMedia = 'dynamic-elements-list-media';
export const dynamicElementsListProducts = 'dynamic-elements-list-products';
export const dynamicElementsMediaPreview = 'dynamic-elements-media-preview';
export const dynamicElementsNewsFeed = 'dynamic-elements-news-feed';
export const dynamicElementsOrderStatusesKey =
  'dynamic-elements-order-statuses';
export const dynamicElementsOrderProductThumbKey =
  'dynamic-order-product-thumb';
export const dynamicElementsPopoverWrapperKey =
  'dynamic-elements-popover-wrapper';
export const dynamicElementsDropdownWrapperKey =
  'dynamic-elements-dropdown-wrapper';
export const dynamicElementsProductCardKey = 'dynamic-elements-product-card';
export const dynamicElementsProductCardHeader =
  'dynamic-elements-product-card-header';
export const dynamicElementsProductCardIcons =
  'dynamic-elements-product-card-icons';
export const dynamicElementsScrollableContainer =
  'dynamic-elements-scrollable-container';
export const dynamicElementsSimpleTextKey = 'dynamic-elements-simple-text';
export const dynamicElementsCircleTextKey = 'dynamic-elements-circle-text';
export const dynamicElementsSortHeaderKey = 'dynamic-elements-sort-header';
export const dynamicElementsSpotlightListsKey =
  'dynamic-elements-spotlight-lists';
export const dynamicElementsTabs = 'dynamic-elements-tabs';
export const dynamicElementsTextKey = 'dynamic-elements-text';
export const dynamicElementsTexMarkdowntKey = 'dynamic-elements-text-markdown';
export const dynamicElementsShowMoreCollapseKey =
  'dynamic-elements-show-more-collapse';
export const dynamicElementsSimpleSelectKey = 'dynamic-elements-simple-select';
export const dynamicElementsSlidingCarouselKey =
  'dynamic-elements-sliding-carousel';
export const epcBasketNotification = 'epc-basket-notification';
export const dynamicElementsFancyList = 'dynamic-elements-fancy-list';
export const dynamicElementsFancyListNavigation =
  'dynamic-elements-fancy-list-navigation';
export const dynamicElementsFancyListItem = 'dynamic-elements-fancy-list-item';
export const dynamicElementsClickableAmountInput =
  'dynamic-elements-clickable-amount-item';

export const dynamicElementsInputWithIconKey =
  'dynamic-elements-input-With-icon-key';
export const dynamicElementsColorPicker = 'dynamic-elements-color-picker';
export const dynamicElementsFilterSelect = 'dynamic-elements-filter-select';
export const dynamicElementsHorizontalProductCard =
  'dynamic-elements-hotrizontal-product-card';
export const dynamicElementsPriceRange = 'dynamic-elements-price-range';
export const dynamicElementsPillsNavigation =
  'dynamic-elements-pills-navigation';
export const dynamicElementsUserFeedbackKey = 'dynamic-user-feedback';
